import { digger } from './digger';
import { Data, MinerSubset } from './model';

/**
 * Retrieves a subset data from an object by providing a subset object with
 * a name and the path to the property.
 *
 * @param universe Universe from where data is required
 * @param subset Object used to build an object based on
 *   a universe
 *
 * @example
 *   const subset = { propertyName: 'property.property_name', area: 'available_space' };
 *   const { propertyName, area } = miner(availability, subset);
 */
export const miner = (universe: Data, subset: MinerSubset): any => {
  return Object.entries(subset)
    .map(([name, path]) => ({ [name]: digger(universe, path) }))
    .reduce((a, b) => ({ ...a, ...b }), {});
};
